import React from "react";
import { Phone, MapPin, Sparkles } from "lucide-react";

export default function Footer() {
  return (
    <footer
      className="bg-[#1A365D] text-white"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-7">
            <div className="text-xs uppercase tracking-[0.25em] text-white/60 mb-5">
              Let&apos;s talk
            </div>
            <h3 className="font-serif text-5xl md:text-7xl leading-[0.95] tracking-tight">
              Sparkle starts with
              <br />
              <span className="italic text-[#E8F1F2]">a simple text.</span>
            </h3>
            <p className="mt-8 max-w-lg text-white/70 font-light leading-relaxed">
              Residential or commercial, our team is one text away. Send a
              quote request or ring the number below on weekdays.
            </p>
          </div>

          <div className="md:col-span-5 flex flex-col gap-6">
            <a
              href="tel:+16085772761"
              className="group flex items-center gap-4 rounded-2xl border border-white/15 bg-white/5 p-5 hover:bg-white/10 transition-colors"
              data-testid="footer-phone"
            >
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-white text-[#1A365D]">
                <Phone className="h-5 w-5" />
              </span>
              <div>
                <div className="text-xs uppercase tracking-[0.18em] text-white/60">
                  Call / text
                </div>
                <div className="font-serif text-2xl">608-577-2761</div>
              </div>
            </a>
            <div className="flex items-center gap-4 rounded-2xl border border-white/15 bg-white/5 p-5">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-white text-[#1A365D]">
                <MapPin className="h-5 w-5" />
              </span>
              <div>
                <div className="text-xs uppercase tracking-[0.18em] text-white/60">
                  Service area
                </div>
                <div className="font-serif text-xl">
                  San Angelo &amp; surrounding West Texas
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-sm text-white/60">
          <div className="flex items-center gap-2">
            <Sparkles className="h-4 w-4" />
            <span className="font-serif text-lg text-white">
              No Grime, Window Shine
            </span>
          </div>
          <div>&copy; 2026 &mdash; Window Shine LLC</div>
        </div>
      </div>
    </footer>
  );
}
